var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPancil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2262 2.40795C12.6163 2.01707 13.2492 2.01678 13.6397 2.4073L15.7566 4.52413C16.1471 4.91466 16.1474 5.54811 15.7572 5.939L8.83163 12.8774C8.69618 13.0131 8.52459 13.107 8.33733 13.1478L5.63505 13.7372C4.92426 13.8922 4.29138 13.2595 4.44536 12.5479L5.03094 9.84156C5.07153 9.65396 5.16518 9.48201 5.30072 9.34622L12.2262 2.40795Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2869 4.7041L13.8179 8.23515",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49561 17.8477H15.9956",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPancil);
export default __webpack_public_path__ + "static/media/editPancil.a9296dbc65614a38515fa3df95c20c16.svg";
export { ForwardRef as ReactComponent };